import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import * as _ from "lodash";
import { setCurrentSelectedContract } from "../../../reducers/contracts";
import { useTranslation } from "react-i18next";
import {
  Dropdown,
  DropdownIndicator,
  formatOptionLabel,
} from "./common/components";
import { Form } from "react-bootstrap";
import "../../CaseGenerator/FormFields/SelectSearch.scss";
import "../../CaseGenerator/FormFields/ContractSelectWithRemoteOptionsField.scss";

const ContractsSelectWithEmptyOption = (props) => {
  const [isKeyboard, setIsKeyboard] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        setIsKeyboard(true);
      } else if (e.key === "Tab") {
        setIsKeyboard(false);
      }
    };

    const handleMouseMove = () => {
      setIsKeyboard(false);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const CustomMenuList = (props) => {
    const { innerRef, innerProps, children, selectProps } = props;

    return (
      <ul
        id={selectProps.menuId || "contract-list"}
        className="contract-list"
        role="listbox"
        ref={innerRef}
        {...innerProps}
      >
        {children}
      </ul>
    );
  };

  const CustomOption = (props) => {
    const { innerRef, innerProps, isFocused, data, children } = props;

    return (
      <li
        ref={innerRef}
        role="option"
        aria-selected={currentSelectedContract.id === data.id}
        {...innerProps}
        className={[
          "custom-option",
          isFocused && isKeyboard ? "is-focused" : "",
        ]
          .join(" ")
          .trim()}
      >
        {children ?? data.label}
      </li>
    );
  };

  const options = useSelector((state) => {
    let temporaryOptions =
      state.contracts.list &&
      state.contracts.list.map((contract) => {
        return {
          name: contract.name || "",
          id: contract.id || "",
          state: contract.state || "",
          clientId: contract.clientId || "",
          clientCode: contract.clientCode || "",
        };
      });
    if (
      state.contracts.currentClientCodeSelected &&
      state.contracts.currentClientCodeSelected.clientCode !== "0"
    ) {
      return temporaryOptions.filter((contract) => {
        if (
          contract.clientCode ===
          state.contracts.currentClientCodeSelected.clientCode
        ) {
          return contract;
        }
      });
    } else {
      return temporaryOptions;
    }
  });

  let optionChooseContract = { id: "0" };
  let optionsWithChooseContract = [optionChooseContract].concat(options);
  let currentSelectedContract = useSelector(
    (state) => state.contracts.currentContractSelected
  );

  const [value, setValue] = useState(currentSelectedContract);
  const [isOpen, setIsOpen] = useState(false);
  const { onUpdate, label } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const triggerUpdated = (selected) => {
    if (onUpdate) {
      onUpdate(selected);
    }
    setIsOpen(false);

    let [currentContract] = _.filter(optionsWithChooseContract, (o) => {
      return o.id === selected ? o : null;
    });
    dispatch(setCurrentSelectedContract(currentContract));
    setValue(currentContract);
  };

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const filterOption = (candidate, input) => {
    if (input) {
      return Object.values(candidate.data).some((item) => {
        if (!item) {
          return false;
        }
        return (
          item.indexOf(input) !== -1 || item.indexOf(input.toUpperCase()) !== -1
        );
      });
    }
    return true;
  };
  return (
    <Form.Group>
      {label && <Form.Label
              className="paragraph-small-fs9"
              htmlFor="contract-select"
              > {label} </Form.Label>}
      <div
        className="ContractsSelect withEmptyOption"
        data-testid="ContractsSelect"
      >
        <Dropdown
          isOpen={value ? isOpen : false}
          onClose={toggleOpen}
          aria-expanded={isOpen}
          target={
            <div
              className={`form-control select-remote-options dropdown ${isOpen}`}
            >
              <button
                onClick={currentSelectedContract && toggleOpen}
                className="btn btn-contract-select btn-default  select-contracts"
                type="button"
              >
                {currentSelectedContract &&
                currentSelectedContract.id === "0" ? (
                  <>
                    <span className="button-text">
                      {t(`common.documentType.all`)}
                    </span>
                    <span className="gc-icon-functional-chevron-down contract-select-icon" />
                  </>
                ) : value && value.state ? (
                  <>
                    <span className={"font-bold badge badge--" + value.state}>
                      {t(`contract.select.state.${value.state}`)}
                    </span>
                    <span className="button-text">{value.name}</span>
                    <span className="gc-icon-functional-chevron-down contract-select-icon" />
                  </>
                ) : (
                  <>
                    <span className="button-text">
                      {t(`contract.select.no.available`)}
                    </span>
                  </>
                )}
              </button>
            </div>
          }
          id={"contract-select-dropdown"}
        >
          <Select
            autoFocus
            backspaceRemovesValue={false}
            value={value}
            formatOptionLabel={formatOptionLabel}
            options={optionsWithChooseContract}
            components={{
              DropdownIndicator,
              IndicatorSeparator: null,
              MenuList: CustomMenuList,
              Option: CustomOption,
            }}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            menuIsOpen
            onChange={(data) => triggerUpdated(data.id)}
            className={"gcap-select form-control"}
            isDisabled={optionsWithChooseContract.length <= 0}
            placeholder={
              optionsWithChooseContract.length > 0
                ? t(`contract.select.placeholder`)
                : t(`contract.select.no.available`)
            }
            filterOption={filterOption}
            tabSelectsValue={false}
            id="contract-select"
          />
        </Dropdown>
      </div>
    </Form.Group>
  );
};

export default ContractsSelectWithEmptyOption;
